import React, { useState, useEffect } from "react";
import EServiceItem from "../../../components/EServiceItem";
import axios from "axios";
import SectionHeader from "./SectionHeader";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";

const OnlineServices = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/services/online/`)
      .then((res) => {
        setServices(res.data);
      })
      .then(() => {
        setIsServicesLoading(false);
      });
  }, []);

  const controlCard = useAnimation();
  const [refCard, inViewCard] = useInView();
  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };
  useEffect(() => {
    if (inViewCard) {
      controlCard.start("visible");
    }
  }, [controlCard, inViewCard]);

  return (
    <div className="eservices-wrapper">
      <div className="container">
        <div className="row">
          <SectionHeader
            title={getContent(content, "Online services", lang)}
            content={getContent(content, "Online services content", lang)}
          />
        </div>
        <motion.div
          variants={list}
          ref={refCard}
          initial="hidden"
          animate={controlCard}
          className="row justify-content-center"
        >
          {isServicesLoading === true ? (
            <>
              <h1>Loading...</h1>
              <h1>Loading...</h1>
              <h1>Loading...</h1>
              <h1>Loading...</h1>
            </>
          ) : (
            services.map((service) => (
              <EServiceItem service={service} key={service["id"]} />
            ))
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default OnlineServices;
